import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Dashboard from './views/Dashboard';
import DashboardLayout from './layouts/DashboardLayout';
import LoginPage from './views/Admin-Login';
import CustomerList from './views/Customer-Details-List';
import ProfileSettings from './views/Settings';
import CustomerDetailsCreate from './views/Customer-Details-Form';
import { ToastContainer } from 'react-toastify';
import CustomerPay from './views/Customer-Pay';
import CustomerView from './views/Customer-View';
import { useState } from 'react';
import AddInvestor from './views/Add-Investor-Details';
import AddFinance from './views/Add-Finance-Details';
import CustomerCollections from './views/Customer-Collections';
import Reports from './views/Reports';

function App() {
    const [customerList, setCustomerList] = useState([]);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LoginPage />} />
          <Route element={<DashboardLayout />}>
            <Route path="/dashboard" element={<Dashboard   customerList={customerList}
            setCustomerList={setCustomerList} />} />
            <Route path="/customer-list" element={<CustomerList />} />
            <Route path="/profile-settings" element={<ProfileSettings />} />
            <Route path="/customer-details/create" element={<CustomerDetailsCreate />} />
            <Route path="/customer-details/edit/:id" element={<CustomerDetailsCreate />} />
            <Route path="/customer-pay/:id" element={<CustomerPay />} />
            <Route path="/customer-view/:id" element={<CustomerView />} />
            <Route path="/add-investor-details" element={<AddInvestor />} />
            <Route path='/add-finance-details' element={<AddFinance />} />
            <Route path='/collections' element={<CustomerCollections />} />
            <Route path='/reports' element={<Reports />} />


          </Route>
        </Routes>

      </BrowserRouter>
      <ToastContainer
        className="toast-position"
        position="bottom-right"
        autoClose={1000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        // theme="dark"
        style={{ width: "500px" }}
      // #00D26E
      />

    </div>
  );
}

export default App;
